import { ReactElement } from 'react';
import { AccordionItemProps } from './AccordionItem';
import { FCWW } from 'types';

interface AccordionProps {
  children: ReactElement<AccordionItemProps>[] | ReactElement<AccordionItemProps>;
}

export const Accordion: FCWW<AccordionProps> = ({ children }) => {
  return <div className="col-12 accordion-root">{children}</div>;
};
